import React from 'react'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import InputRow from '../elements/InputRow'
import { connect } from 'react-redux'
import { setMfaValidated } from '../redux/actions'
import LoginHOC from "../auth/LoginHOC";

const options = {
    postUrl: `${process.env.MIX_API_URL}v1/verify-mfa`,
    success: "MFA code successful! Redirecting you to My Exetel."
}

const state = {
    action: '',
    token: ''
}

const MfaCodeForm = (props) => {

    return (
        <form onSubmit={props.handleSubmit} onKeyDown={props.handleKeyDown}>
            <div>
                <p>Please provide the one-time verification code sent to you.</p>
                <p>This is a process called Multi-Factor Authentication (MFA), which has been introduced to strengthen the security of your account.</p>
            </div>

            <InputRow
                label='4 digit code'
                name='token'
                value={props.values.token}
                errors={props.errors}
                handleChange={props.handleInputChange}
                placeholder='4 digit code'
                type='password'
            />

            {props.children}

            <div className='mt-lg-4 d-lg-flex'>
                <Button title='Verify' action={props.handleSubmit} className="mr-lg-3 mb-2 mb-lg-0" />
                <Button title='Resend Code' action={props.handleResendCode} color="darkgrey" />
            </div>
        </form>
    )
}


const mapStateToProps = state => ({
    id: state.auth.id,
    redirectTo: state.auth.redirectTo
})


export default connect(mapStateToProps, { setMfaValidated })(LoginHOC(FormHOC(MfaCodeForm, state, options)))



// WEBPACK FOOTER //
// ./resources/js/forms/MfaCodeForm.js